export const MISSING_DAY_OF_WEEK_FIELD = 'MISSING_DAY_OF_WEEK_FIELD';
export const MISSING_DAY_OF_MONTH_FIELD = 'MISSING_DAY_OF_MONTH_FIELD';
export const TranslatedErrorMessageKey = {
  MISSING_DAY_OF_WEEK_FIELD: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.validation.missingDayOfWeekField',
  MISSING_DAY_OF_MONTH_FIELD: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.validation.missingDayOfMonthField'
};